<template>
  <div class="home-service-parent">
    <div class="home-service" v-if="count >= 3">
      <div class="top">
        <div class="title">
          <div class="zh">商品营销</div>
          <div class="en">Product Marketing</div>
        </div>
        <div
          class="content"
        >商品营销模块包含了永辉各类好玩的营销活动，面对琳琅满目的商品，如何抓住小主们的心，打造爆款营销？不同时令节气，主推什么商品？在这里或许有不一样的灵感。</div>
        <div class="link" @click="goto('/service/fwxs')">
          {{count}} 条商品营销
          <img src="@/assets/index/全部商品2.png" />
        </div>
      </div>
      <div class="bottom">
        <div
          :class="activeIndex == index ? 'item item-active': 'item'"
          v-for="(item, index) in list"
          :key="index"
          @mouseover="hover(index)"
          @click="goto('/service/detail/' + item.id, true)"
        >
          <img :src="util.getFirstImage(item.image, '440x220')" />
          <div class="intro animated slideInUp faster" v-show="activeIndex == index">
            <div class="title">{{item.name}}</div>
            <div class="content">{{item.description}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeBaike",
  props: {
    list: Array,
    count: Number
  },
  data() {
    return {
      activeIndex: 0
    };
  },
  methods: {
    hover(index) {
      this.activeIndex = index;
    },
    goto(path, open) {
      if (open) {
        window.open(path);
      } else {
        this.$router.push(path);
      }
    }
  }
};
</script>

<style lang="less" scoped>
.home-service-parent {
  width: 100%;
  background: rgba(252, 252, 252, 1);
}
.home-service {
  width: 1100px;
  margin: 60px auto;

  .top {
    text-align: center;
    margin-bottom: 40px;
    .title {
      text-align: center;
      .zh {
        font-size: 28px;
        font-family: "FZQKBYSJW";
        font-weight: normal;
        color: rgba(51, 51, 51, 1);
        line-height: 31px;
        padding-top: 45px;
      }

      .en {
        font-size: 14px;
        font-weight: 200;
        color: rgba(132, 135, 145, 1);
        line-height: 20px;
        margin: 10px 0 30px 0;
      }
    }

    .content {
      margin: 20px auto;
      font-size: 16px;
      font-weight: 200;
      color: rgba(51, 51, 51, 1);
      line-height: 28px;
      text-align: center;
      width: 800px;
    }

    .link {
      display: inline-block;
      height: 36px;
      line-height: 36px;
      padding: 0 10px;
      border: 1px solid rgba(132, 135, 145, 0.5);
      font-size: 12px;
      font-weight: 200;
      color: rgba(132, 135, 145, 1);
      cursor: pointer;
      img {
        width: 12px;
        margin-left: 24px;
      }
    }

    .link:hover {
      border: 1px solid rgba(51, 51, 51, 1);
      background: rgba(51, 51, 51, 1);
      color: white;
    }
  }

  .bottom {
    padding-bottom: 40px;
    .item {
      width: 220px;
      height: 220px;
      display: inline-block;
      overflow: hidden;
      cursor: pointer;
      position: relative;
      transition: all 0.4s ease-out;
    }

    .item-active {
      width: 440px;
      //   transition: all 0.6s ease-out;
    }

    .intro {
      position: absolute;
      height: 110px;
      width: 440px;
      top: 110px;
      background: linear-gradient(
        180deg,
        rgba(0, 0, 0, 0) 0%,
        rgba(0, 0, 0, 1) 100%
      );
      .title {
        font-size: 20px;
        font-family: "FZQKBYSJW";
        font-weight: normal;
        color: rgba(255, 255, 255, 1);
        line-height: 22px;
        margin: 40px 15px 10px 15px;
      }
      .content {
        font-size: 12px;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        line-height: 16px;
        margin: 0px 15px 0 15px;
      }
    }
  }
}
</style>